export default __webpack_public_path__ + "static/media/active.44b6b8f4.svg";